import React from 'react'
import { getStorage } from '../modals/Storage';
import '../../MainStyle.css';

function PaymentFailed(){
    return (
      <div className='v-center'>
        <div className="h-100vh pr-v res-wth ovf-scrl-y hide-sb bg-white">
          <div className="col-view mg-t-45">

            <div className={`w-100 col-view v-center pd-0-30 mg-t-55`}>
              <img className="h-70-p" src={require('../icons/error-icon.png')} />

              <p className='ft-sz-20 mg-t-15'>Payment Failed</p>
              <p className='ft-sz-13 mg-t-10'>Payment Id: {getStorage("sessionPayId")}</p>
              <p className='ft-sz-13 mg-t-10'>Note: Payment failed due to timeout.</p>
            </div>

          </div>
        </div>
      </div>
    );
}

export default PaymentFailed;